export const DISTRIBUTION_THRESHOLDS = {

  DEFAULT_MIN_THRESHOLD: 100,

  MIN_REALISTIC_THRESHOLD: 1,

  DAYS_BETWEEN_DISTRIBUTIONS: 14,
} as const

export const READINESS_THRESHOLDS = {

  ALMOST_READY: 80,

  FEES_READY: 100,
} as const

export const WORKFLOW_STEPS = {
  CONFIGURE: 'configure',
  DRY_RUN: 'dry-run',
  REVIEW: 'review',
  EXECUTE: 'execute',
  COMPLETE: 'complete',
} as const

export type WorkflowStep = typeof WORKFLOW_STEPS[keyof typeof WORKFLOW_STEPS]

export const WORKFLOW_STEP_DEFINITIONS = {
  [WORKFLOW_STEPS.CONFIGURE]: {
    name: 'Configure',
    description: 'Set distribution parameters',
  },
  [WORKFLOW_STEPS.DRY_RUN]: {
    name: 'Dry Run',
    description: 'Validate without executing',
  },
  [WORKFLOW_STEPS.REVIEW]: {
    name: 'Review',
    description: 'Verify distribution preview',
  },
  [WORKFLOW_STEPS.EXECUTE]: {
    name: 'Execute',
    description: 'Deploy to blockchain',
  },
  [WORKFLOW_STEPS.COMPLETE]: {
    name: 'Complete',
    description: 'Distribution finished',
  },
} as const

export const CONTRACT_STEP_NAMES = new Set([
  'Contract Approval',
  'Withdraw Fees',
  'Set Claim Window',
])

export const DISTRIBUTION_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const

export type DistributionStatus = typeof DISTRIBUTION_STATUS[keyof typeof DISTRIBUTION_STATUS]

export const DISTRIBUTION_STATUS_LABELS: Record<DistributionStatus, string> = {
  [DISTRIBUTION_STATUS.PENDING]: 'Pending',
  [DISTRIBUTION_STATUS.COMPLETED]: 'Completed',
  [DISTRIBUTION_STATUS.FAILED]: 'Failed',
} as const

export const DISTRIBUTION_READINESS = {
  READY: 'ready',
  ALMOST: 'almost',
  WAITING: 'waiting',
  BLOCKED: 'blocked',
} as const

export type DistributionReadiness = typeof DISTRIBUTION_READINESS[keyof typeof DISTRIBUTION_READINESS]

export const CLAIM_RATE_TONES = {

  COMPLETE: 'accent',

  PARTIAL: 'warn',

  LOW: 'neutral',

  PARTIAL_THRESHOLD: 50,
} as const

export const DISTRIBUTION_FILENAME = {
  PREFIX: 'avow-proofs',
} as const
